import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { moneyFormat, qtyFormat } from '../common/helpers';
import { covertToDate } from '../../common/formater';
import { Box, Grid, Typography, colors } from '@material-ui/core';

export default function PrintTable({
  value,
  classnames,
  classes,
  style,
  rows,
  columns,
  data,
  addTotal,
  isPOS,
  isRTL,
}: any) {
  const clss = classnames?.map((cn: any) => classes?.cn);
  const className = clss.join(' ');
  const { amount, discount, total } = data;
  const nrows = rows?.map((row: any, index: any) => {
    const col = columns?.[index];
    return {
      ...row,
      width: col?.width,
      align: col?.align,
    };
  });
  const cols = columns?.length;
  const percentage = discount && discount > 0 ? (discount * 100) / total : null;
  return (
    <TableContainer className={className} style={style}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow style={{ backgroundColor: isPOS ? undefined : '#ddd' }}>
            {columns?.map((col: any) => {
              const { id, value, width, height, bold, size, color } = col;
              return (
                <TableCell
                  key={id}
                  style={{
                    fontWeight: bold ? 'bold' : undefined,
                    fontSize: size ? Number(size) : 16,
                    color,
                    margin: isPOS ? 0 : undefined,
                    padding: isPOS ? 7 : undefined,
                    fontFamily: 'Arial',
                    wordWrap: 'normal',
                    letterSpacing: 'normal',
                  }}
                  variant="head"
                  height={Number(height)}
                  width={Number(width)}
                  align={'center'}
                >
                  {value}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {nrows?.map((row: any) => {
            return (
              <TableRow
                style={{
                  backgroundColor: isPOS ? undefined : '#f7f7f7',
                }}
              >
                {columns?.map((col: any) => {
                  const {
                    name,
                    width,
                    align,
                    money,
                    qty,
                    date,
                    relation,
                    itemdesc,
                    custrelation,
                    itemheight,
                    itemsize,
                    color,
                  } = col;

                  const value = row?.[name];
                  return (
                    <TableCell
                      style={{
                        fontWeight: isPOS ? 'bold' : undefined,
                        fontSize: itemsize ? Number(itemsize) : 16,
                        color,
                        margin: isPOS ? 0 : undefined,
                        padding: isPOS ? 4 : undefined,
                        fontFamily: 'Arial',
                        wordWrap: 'normal',
                        letterSpacing: 'normal',
                      }}
                      height={Number(itemheight)}
                      width={Number(width)}
                      align={
                        isRTL ? align : align === 'left' ? 'right' : 'left'
                      }
                    >
                      {money
                        ? moneyFormat(value)
                        : qty
                        ? qtyFormat(value)
                        : date
                        ? covertToDate(value)
                        : relation
                        ? renderRelations(row, isRTL)
                        : itemdesc
                        ? renderNameDesc(row, isRTL)
                        : custrelation
                        ? custsuppRelations(row, isRTL)
                        : value}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {addTotal && (
        <Table
          style={{ breakInside: 'avoid' }}
          size="small"
          aria-label="a dense table"
        >
          <TableBody>
            {!isPOS && (
              <TableRow
                style={{
                  height: 35,
                  backgroundColor: '#f7f7f7',
                }}
              >
                <TableCell colSpan={cols} />
              </TableRow>
            )}
            <TableRow
              style={{
                height: isPOS ? 30 : 40,
                backgroundColor: isPOS ? undefined : '#f7f7f7',
              }}
            >
              <TableCell />
              <TableCell
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  wordWrap: 'normal',
                  letterSpacing: 'normal',
                  color: '#000000',
                }}
                align={isRTL ? 'left' : 'right'}
                colSpan={cols - 2}
              >
                Subtotal المجموع
              </TableCell>
              <TableCell
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  color: '#000000',
                }}
                align={isRTL ? 'left' : 'right'}
              >
                {moneyFormat(total)}
              </TableCell>
            </TableRow>
            <TableRow
              style={{
                height: isPOS ? 30 : 40,
                backgroundColor: isPOS ? undefined : '#f7f7f7',
              }}
            >
              <TableCell />
              <TableCell
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  wordWrap: 'normal',
                  letterSpacing: 'normal',
                  color: '#000000',
                }}
                align={isRTL ? 'left' : 'right'}
                colSpan={cols - 2}
              >
                {percentage && percentage > 0
                  ? `(${moneyFormat(percentage)}%) Discount الحسم`
                  : 'Discount الحسم'}
              </TableCell>
              <TableCell
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  color: '#000000',
                }}
                align={isRTL ? 'left' : 'right'}
              >
                {moneyFormat(discount)}
              </TableCell>
            </TableRow>
            <TableRow
              style={{
                height: isPOS ? 30 : 40,
                backgroundColor: isPOS ? undefined : '#ddd',
              }}
            >
              <TableCell />
              <TableCell
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  wordWrap: 'normal',
                  letterSpacing: 'normal',
                  color: '#000000',
                }}
                colSpan={isPOS ? cols - 2 : cols - 2}
                align={isRTL ? 'left' : 'right'}
              >
                Net Amount الصافي
              </TableCell>
              <TableCell
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  fontFamily: 'Arial',
                  color: '#000000',
                }}
                align={isRTL ? 'left' : 'right'}
              >
                {moneyFormat(amount)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
}

const renderRelations = (row: any, isRTL: any) => {
  const {
    contractName,
    contractNameAr,
    resourseName,
    resourseNameAr,
    departmentName,
    departmentNameAr,
    employeeName,
    employeeNameAr,
    customerName,
    customerNameAr,
    supplierName,
    supplierNameAr,
    opaccName,
    opaccNameAr,
  } = row;
  const customer = isRTL ? customerNameAr : customerName;
  const supplier = isRTL ? supplierNameAr : supplierName;
  const contract = isRTL ? contractNameAr : contractName;
  const resourse = isRTL ? resourseNameAr : resourseName;
  const employee = isRTL ? employeeNameAr : employeeName;
  const department = isRTL ? departmentNameAr : departmentName;
  const opaccount = isRTL ? opaccNameAr : opaccName;
  return (
    <Grid container spacing={1}>
      {customer && (
        <Grid item xs={12}>
          {renderTag({ value: customer, bgcolor: bgcolors.blue })}
        </Grid>
      )}
      {supplier && (
        <Grid item xs={12}>
          {renderTag({ value: supplier, bgcolor: bgcolors.blue })}
        </Grid>
      )}
      {contract && (
        <Grid item xs={12}>
          {renderTag({ value: contract, bgcolor: bgcolors.green })}
        </Grid>
      )}
      {resourse && (
        <Grid item xs={12}>
          {renderTag({ value: resourse, bgcolor: bgcolors.green })}
        </Grid>
      )}
      {employee && (
        <Grid item xs={12}>
          {renderTag({ value: employee, bgcolor: bgcolors.green })}
        </Grid>
      )}
      {department && (
        <Grid item xs={12}>
          {renderTag({ value: department, bgcolor: bgcolors.green })}
        </Grid>
      )}
      {opaccount && (
        <Grid item xs={12}>
          {renderTag({ value: opaccount, bgcolor: bgcolors.green })}
        </Grid>
      )}
    </Grid>
  );
};
const renderNameDesc = (row: any, isRTL: any) => {
  const { name, nameAr, itemName, itemNameAr, desc } = row;
  const fname = name ? (isRTL ? nameAr : name) : isRTL ? itemNameAr : itemName;
  if (desc) {
    return (
      <>{renderTag({ value: desc, fontSize: 12, fontWeight: 'normal' })}</>
    );
  } else {
    return (
      <>{renderTag({ value: fname, fontSize: 13, fontWeight: 'normal' })}</>
    );
  }
  // return (
  //   <Grid container spacing={1}>
  //     <Grid item xs={12}>
  //       {renderTag({ value: fname, fontSize: 13, fontWeight: 'normal' })}
  //     </Grid>
  //     <Grid item xs={12}>
  //       {renderTag({ value: desc, fontSize: 12, fontWeight: 'normal' })}
  //     </Grid>
  //   </Grid>
  // );
};

const custsuppRelations = (row: any, isRTL: any) => {
  const { customerName, customerNameAr, supplierName, supplierNameAr } = row;
  const customer = isRTL ? customerNameAr : customerName;
  const supplier = isRTL ? supplierNameAr : supplierName;
  return (
    <Grid container spacing={1}>
      {customer && (
        <Grid item xs={12}>
          {renderTag({ value: customer, bgcolor: colors.grey[200] })}
        </Grid>
      )}
      {supplier && (
        <Grid item xs={12}>
          {renderTag({ value: supplier, bgcolor: colors.grey[200] })}
        </Grid>
      )}
    </Grid>
  );
};

const renderTag = ({
  value,
  color,
  bgcolor,
  fontSize = 12,
  fontWeight = 'bold',
}: any) => {
  if (!value) return <></>;
  return (
    <Box
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: bgcolor,
        borderRadius: 5,
      }}
    >
      <Typography
        style={{
          fontSize,
          fontWeight,
          color,
          textAlign: 'right',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

const bgcolors = {
  blue: colors.blue[50],
  green: colors.green[50],
  customer: colors.blue[50],
  supplier: colors.purple[50],
  contract: colors.green[50],
  resourse: colors.orange[50],
  employee: colors.red[50],
  department: colors.yellow[50],
};
